import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  padding: 16px;
  background-color: #1c1c1c;
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const TextContainer = styled.div`
  margin-right: 33px;
  h4 {
    margin: 0;
    font-family: "Gilroy";
    font-weight: bold;
    margin-bottom: 24px;
    color: white;
  }
  p {
    color: white;
  }
`;

const MagnifierIcon = styled.div`
  display: flex;
  align-items: center;
`;

export default function LostYourBraceletCard() {
  return (
    <Container>
      <TextContainer>
        <h4>LOST YOUR BRACELET?</h4>
        <p>Show this QR to our staffs</p>
      </TextContainer>
      <MagnifierIcon>
        <svg
          width="52"
          height="61"
          viewBox="0 0 52 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.6332 54.4704C18.825 54.0102 19.1442 53.6275 19.5906 53.3224C20.0474 53.0217 20.4903 52.8134 20.9192 52.6975C21.3525 52.5711 21.7771 52.392 22.193 52.1601C22.6193 51.9326 22.9044 51.6463 23.0483 51.3011C23.2009 50.9349 23.1931 50.6002 23.0249 50.2968C22.8567 49.9934 22.5476 49.7479 22.0978 49.5604C21.2191 49.1942 20.4026 49.4003 19.6484 50.1787L18.2416 48.3399C18.878 47.6966 19.6235 47.3074 20.4778 47.1724C21.347 47.0313 22.2053 47.1373 23.0526 47.4905C24.0046 47.8872 24.7103 48.5067 25.1696 49.3489C25.6438 50.185 25.6803 51.0843 25.2792 52.0467C25.096 52.4861 24.8318 52.8548 24.4866 53.1529C24.1518 53.4554 23.7969 53.6881 23.422 53.8511C23.062 54.008 22.701 54.1522 22.3392 54.2838C21.9922 54.4093 21.6723 54.5584 21.3793 54.731C21.0968 54.9079 20.9033 55.1219 20.7986 55.373L18.6332 54.4704ZM19.199 58.8134C18.8284 58.9659 18.4601 58.9658 18.094 58.8132C17.7278 58.6606 17.4685 58.3991 17.316 58.0285C17.1634 57.658 17.1635 57.2897 17.3161 56.9235C17.4687 56.5574 17.7303 56.2981 18.1008 56.1455C18.4713 55.993 18.8397 55.9931 19.2058 56.1457C19.5719 56.2983 19.8313 56.5598 19.9838 56.9304C20.1363 57.3009 20.1363 57.6692 19.9837 58.0354C19.8311 58.4015 19.5695 58.6608 19.199 58.8134Z"
            fill="#F0E500"
          />
          <path
            d="M45.4646 37.6861C45.4283 37.0418 45.584 36.4161 45.9318 35.8089C46.2941 35.2009 46.6924 34.7084 47.1266 34.3314C47.5599 33.9397 47.9533 33.4915 48.3068 32.9869C48.675 32.4814 48.8454 31.987 48.8182 31.5038C48.7894 30.9912 48.5914 30.6058 48.2243 30.3473C47.8571 30.0889 47.3588 29.9774 46.7291 30.0129C45.499 30.0822 44.6645 30.7829 44.2253 32.115L41.5493 30.7674C41.9276 29.659 42.5761 28.7851 43.495 28.1458C44.4276 27.491 45.487 27.1302 46.6731 27.0634C48.0057 26.9883 49.1771 27.3116 50.1872 28.0333C51.2112 28.7395 51.7612 29.7662 51.8371 31.1134C51.8717 31.7284 51.7721 32.3069 51.5382 32.8489C51.3189 33.3901 51.037 33.8614 50.6923 34.2627C50.3615 34.6486 50.0226 35.0203 49.6754 35.3777C49.3421 35.7196 49.0536 36.0738 48.8098 36.44C48.5807 36.8055 48.476 37.164 48.4958 37.5154L45.4646 37.6861ZM48.574 42.4248C48.2285 42.8115 47.7995 43.0193 47.287 43.0481C46.7745 43.077 46.3249 42.9187 45.9382 42.5732C45.5515 42.2278 45.3437 41.7988 45.3148 41.2863C45.2859 40.7737 45.4442 40.3241 45.7897 39.9374C46.1352 39.5507 46.5642 39.3429 47.0767 39.3141C47.5892 39.2852 48.0388 39.4435 48.4255 39.789C48.8122 40.1344 49.02 40.5634 49.0489 41.0759C49.0778 41.5885 48.9195 42.0381 48.574 42.4248Z"
            fill="#F0E500"
          />
          <rect
            x="25.4182"
            y="22.5833"
            width="40.1473"
            height="6.27302"
            rx="2.5"
            transform="rotate(58.4302 25.4182 22.5833)"
            fill="#FC7171"
          />
          <circle cx="20.0737" cy="20.0737" r="20.0737" fill="#FC7171" />
          <circle cx="20.0738" cy="20.0738" r="16.3099" fill="#AFE3FF" />
          <circle cx="25.7192" cy="16.9372" r="5.64572" fill="white" />
        </svg>
      </MagnifierIcon>
    </Container>
  );
}
